module.exports = __webpack_public_path__ + "img/transfer-bank.9b8a91c7.svg";